import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppConfigInterface, AppConfigService } from '../services/app-config.service';

@Injectable()
export class AppConfigInterceptor implements HttpInterceptor {
    
    constructor(private appConfigService: AppConfigService) {
    }
    
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    const appConfig: string = event.headers.get('App-Configuration');
                    if (appConfig) {
                        const configData: AppConfigInterface = JSON.parse(appConfig);
                        this.appConfigService.set(configData);
                    }
                }
            })
        );
    }
}